import React from 'react'
import './NotFound.css'
import { Link } from 'react-router-dom';
import Footer from '../../components/footer/Footer'

function NotFound() {
  const notfoundimg = '/images/notfound/NotfoundImg.png'
  return (
    <div className='nf-bg'>
        <div className='not-found-box'>
            <div className='not-found-left-box'>
                <h1 className='not-found-title'>Oops! Die Seite konnte nicht gefunden werden.</h1>
                <p className='not-found-subtitle'>Die von dir gesuchte Seite existiert nicht.</p>
                <Link className='' href='/' to='/'>
                    <button className="back-to-home-btn"> Zurück zur Startseite</button>	
                </Link>
            </div>
            <div className='not-found-right-box'>
                <img src={notfoundimg} className='not-found-img' alt=''/>
            </div>
        </div>
    <Footer />
    </div>
  );
}

export default NotFound;